/**
 * Path this SPA is served under. The portal owns the root (`/`) of the shared
 * domain, so this is `/` in every environment — the base-aware plumbing exists
 * to mirror the agent console (served under `/agent/`) and stays a no-op here.
 */
export const basePath = import.meta.env.BASE_URL;

/** Router basename (`/` for the portal). */
export const routerBasename = basePath.replace(/\/$/, '') || '/';

/**
 * This SPA's own URL (origin + base, no trailing slash). Used as the Entra
 * redirect URI and the magic-link callback base. Must be registered in Entra.
 */
export const authRedirectUri = (window.location.origin + basePath).replace(/\/+$/, '');

export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  /** IT helpdesk phone number shown to staff (click-to-call). */
  helpdeskPhone: import.meta.env.VITE_HELPDESK_PHONE ?? '',
  entra: {
    clientId: import.meta.env.VITE_ENTRA_CLIENT_ID ?? '',
    tenantId: import.meta.env.VITE_ENTRA_TENANT_ID ?? '',
    apiScope: import.meta.env.VITE_ENTRA_API_SCOPE ?? '',
  },
};

/** Entra is fully configured → use MSAL. */
export const authConfigured = Boolean(
  config.entra.clientId && config.entra.tenantId && config.entra.apiScope,
);

/** Active auth mode: Entra when configured, else magic-link, else dev (open). */
export type AuthMode = 'entra' | 'magic' | 'dev';
export const authMode: AuthMode = authConfigured
  ? 'entra'
  : import.meta.env.VITE_AUTH_MODE === 'magic'
    ? 'magic'
    : 'dev';
